import { render, staticRenderFns } from "./AgreementList.vue?vue&type=template&id=0cf5f432"
import script from "./AgreementList.vue?vue&type=script&lang=js"
export * from "./AgreementList.vue?vue&type=script&lang=js"
import style0 from "./AgreementList.vue?vue&type=style&index=0&id=0cf5f432&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports